import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-89f06932"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "steps-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line todo" }, null, -1))
const _hoisted_3 = { class: "progress-icons" }
const _hoisted_4 = ["src"]

import { computed } from 'vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ProgressSteps',
  props: {
    items: null,
    progress: null
  },
  setup(__props: any) {

const props = __props as {
    items: {label: string, icon: string}[];
    progress: number;
  };

  

  const progressFactor = computed(() => props.items.length !== 1 ? 100 / (props.items.length - 1) : 0);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", {
      class: "line done",
      style: _normalizeStyle(`width: ${props.progress * _unref(progressFactor)}%`)
    }, null, 4),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.items, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "img-container",
          key: item.label
        }, [
          _createElementVNode("img", {
            class: _normalizeClass(index < props.progress ? 'iconBG color-orange' : ''),
            alt: "icon",
            src: require(`../assets/media/icons/${item.icon}`)
          }, null, 10, _hoisted_4)
        ]))
      }), 128))
    ])
  ]))
}
}

})